var array = [];
var prodObj = {};
/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');
    this.price = 0;

    if (this.form.querySelectorAll('[data-bundle-product]').length > 0) {
      this.bundleVariants = this.querySelectorAll('.variant--id');
      this.bundleVariants.forEach(qtyBtn => qtyBtn.addEventListener('change', this.displayPrice.bind(this)));
    }

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyInputs = this.querySelectorAll('input[name="quantity"]')
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    this.qtyInputs.forEach(qtyInput => qtyInput.addEventListener('input', this.manageQtyBtnOnInput.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');

    if (submitButton.hasAttribute('data-purchase-btn')) {
      this.displayOrder(evt);
      window.scrollTo({ top: document.querySelector('[data-order-summary]').offsetTop, behavior: 'smooth' });
      return false;
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    if (submitButton.hasAttribute('data-bundle-add')) {
      if (pdpContainer.querySelectorAll('.variant--id:checked').length < 2 && this.form.querySelectorAll('[data-bundle-product]') != null) {
        this.form.querySelectorAll('[data-bundle-product]').forEach(varContainer => {
          // console.log(varContainer.querySelectorAll('.variant--id:checked').length)
          if (varContainer.querySelectorAll('.variant--id:checked').length <= 0) {
            varContainer.querySelector('.error-text').innerHTML = "This is a required field."
            varContainer.querySelector('.error-text').classList.remove('d-none');
            this.manageResponseText(varContainer.querySelector('.error-text'));
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('loading');
            setTimeout(() => {
              // varContainer.querySelector('.error-text').classList.add('d-none');
            }, 3000);
          }
        });
        return false;
      }
    }
    if (this.form.querySelectorAll('[data-bundle-product]').length <= 0) {
      addItems.push(JSON.parse(serializeForm(this.form)))
    }
    if (pdpContainer) {
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn) => {
        if (!addOn.disabled) {
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }

    if (this.form.querySelectorAll('[data-bundle-product]').length > 0) {
      const MainId = this.querySelector('[data-main-prod]').getAttribute('data-main-prod');
      let timestamp = new Date().valueOf();
      this.form.querySelectorAll('[data-bundle-product]').forEach(element => {
        // console.log(element.querySelector('.variant--id:checked').value);
        let bundleJSON = {
          id: element.querySelector('.variant--id:checked').value,
          quantity: 1,
          properties: { productType: "subProduct", mainProductId: MainId, timestamp: timestamp }
        }
        addItems.push(bundleJSON);
      });
    }
    // console.log(addItems);

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if (document.querySelector('#PopupModal-quickshop')) {
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        this.cartElement.getCartData('open_drawer');
        if (qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  /**
    * fade effect on reponse
    * @param {element} element 
    */
  manageResponseText(element) {
    Utility.fadeEffect(element, 'fadeIn');
    setTimeout(() => {
      Utility.fadeEffect(element, 'fadeOut');
    }, 3000);
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = 0;
    if (currentTarget.closest('.purchase-order-sec')) {
      currentQty = parseInt($qtyInput.value) || 0;
    } else {
      currentQty = parseInt($qtyInput.value) || 1;
    }
    let finalQty = 1;

    if (action == 'decrease' && currentQty <= 1) {
      return false;
    } else if (action == 'decrease') {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }
    if (finalQty > 0 && event.currentTarget.closest('.qty-wrapper-container') != null) {
      if(event.currentTarget.closest('.qty-wrapper-container').querySelector('[data-purchase-btn]') != null){
        event.currentTarget.closest('.qty-wrapper-container').querySelector('[data-purchase-btn]').classList.remove('btn-bulk-button')
      }
    }
    if($qtyInput.hasAttribute('data-update-item')){
      let varID = $qtyInput.getAttribute('data-update-item');
      prodObj[varID].qty = finalQty;
      this.updateHtml(prodObj);
    }

    $qtyInput.value = finalQty;
  }

  /**
  * Product Form Quantity Input update action
  *
  * @param {event} Event instance
  */
  manageQtyBtnOnInput(event) {
    // event.preventDefault();
    let currentTarget = event.currentTarget;
    // console.log('qty', currentTarget.value)
    if (currentTarget.value > 0 && event.currentTarget.closest('.qty-wrapper-container').querySelector('[data-purchase-btn]') != null) {
      event.currentTarget.closest('.qty-wrapper-container').querySelector('[data-purchase-btn]').classList.remove('btn-bulk-button')
    } else if (currentTarget.value <= 0 && event.currentTarget.closest('.qty-wrapper-container').querySelector('[data-purchase-btn]') != null) {
      event.currentTarget.closest('.qty-wrapper-container').querySelector('[data-purchase-btn]').classList.add('btn-bulk-button')
    }
  }
  /**
   * 
   * @param {event} event
   */
  displayOrder(event) {
    let currentTarget = event.currentTarget;
    let prodId = currentTarget.closest('[data-prod-id]').querySelector('input[name="id"]').value;
    let price = currentTarget.closest('[data-prod-id]').querySelector('[data-currentprice]').getAttribute('data-actual-price');
    const optionVar = [];
    currentTarget.closest('[data-prod-id]').querySelectorAll('custom-select').forEach(option => {
      let addVar = {
        title: option.querySelector('.option-name').innerHTML,
        value: option.querySelector('.selected-option').innerHTML
      }
      optionVar.push(addVar)
    })
    let prop = { "_wholesalePrice": price }
    
    let title = currentTarget.closest('[data-prod-id]').querySelector('.product-link').innerHTML;
    let qty = currentTarget.closest('[data-prod-id]').querySelector('input[name="quantity"]').value;
    let _this = this;
    if(!(Object.keys(prodObj).length == 0 && prodObj.constructor == Object)){
      Object.keys(prodObj).forEach(function(key) {
        if (prodObj[key].id == prodId && prodObj[key].qty == qty) {
          currentTarget.closest('.data-b2b-col').querySelector('.error-text').classList.remove('d-none')
          _this.manageResponseText(currentTarget.closest('.data-b2b-col').querySelector('.error-text'));
          return;
        }
      });      
    }  
   
    prodObj[prodId] = {
      "id":prodId,
      "link": currentTarget.closest('[data-prod-id]').querySelector('.product-link').getAttribute('href'),
      "title": currentTarget.closest('[data-prod-id]').querySelector('.product-link').innerHTML,
      "sku": currentTarget.closest('[data-prod-id]').querySelector('.pd-sku span').innerHTML,
      "qty": currentTarget.closest('[data-prod-id]').querySelector('input[name="quantity"]').value,
      "price": price,
      "option": optionVar,
      "properties": prop
    }
    this.updateHtml(prodObj);
  }

  updateHtml(prodObj){
    let orderWrap = document.querySelector('[data-order-summary]');
    orderWrap.innerHTML = '';
    let appedHtml = '';
    let idx = 0;
    let totalPrice = 0;
    let addItemsFinal = [];
    appedHtml += `<div class="order-summary-inner">`
    for (const varId in prodObj) {
      let varOption = '';
      let addOnJSON = {
        id: varId,
        quantity: prodObj[varId].qty,
        properties: prodObj[varId].properties
      }

      addItemsFinal.push(addOnJSON);
      prodObj[varId].option.forEach((ele, index) => {

        if (index == 0) {
          varOption += `<div class="col-4 px-1">
         ${ele.title}: <span class="d-block fw-bold">${ele.value}</span>
          </div>`
        } else {
          varOption += `<div class="col-3 ">
          <span class="ms-auto d-table"> ${ele.title}: <span class="d-block fw-bold">${ele.value}</span>
          </div>`
        }
      });
      let itemClass = "order-item pt-3 mt-3 border-top border-gray-600"
      if (idx == 0) {
        itemClass = 'order-item'
      }
      idx++;

      totalPrice = totalPrice + (prodObj[varId].price * prodObj[varId].qty);

      let total = Shopify.formatMoney((prodObj[varId].price * prodObj[varId].qty), window.globalVariables.money_format)
      
      appedHtml += `<div class="${itemClass}" data-b2b-product="${varId}">
      <a class="product-link text-white text-capitalize fw-bold" role="button" href="${prodObj[varId].link}">${prodObj[varId].title}</a>
      <div class="d-flex no-gutters mt-2 pt-1">
          <div class="col-5">
              SKU: <span class="d-block fw-bold">${prodObj[varId].sku}</span>
          </div>
          ${varOption}
      </div>
      <div class="my-4"> 
          <div class="d-flex align-items-center justify-content-start justify-content-lg-center">
              <span class="me-5 text-uppercase" style="" title="Label Quantity">Qty:</span>
              <div class="quantity-wrapper me-auto" data-qty-container="">
                  <div class="input-group input-group-sm">
                      <div class="input-group-prepend">
                          <a href="#" class="input-group-text bg-transparent border-0" rel="nofollow" aria-label="Decrease quantity ${prodObj[varId].title}" title="Decrease quantity ${prodObj[varId].title}" data-for="decrease" data-qty-btn="">
                          <span class="btn-decrease">
                          <span class="icon-arrow-up-short icon-size-10"></span>
                          </span>
                          <span class="visually-hidden">Decrease quantity ${prodObj[varId].title}</span>
                          </a>
                      </div>
                      <input type="number" name="quantity" aria-label="Quantity for ${prodObj[varId].title}" value="${prodObj[varId].qty}" step="0" min="0" inputmode="numeric" data-qty-input="" class="quantity form-control px-4 text-start" data-update-item="${varId}" readonly>
                      <div class="input-group-append">
                          <a href="#" class="input-group-text bg-transparent border-0 " rel="nofollow" aria-label="Increase quantity ${prodObj[varId].title}" title="Increase quantity ${prodObj[varId].title}" data-for="increase" data-qty-btn="">
                          <span class="btn-increase">
                          <span class="icon-arrow-up-short icon-size-10"></span>
                          </span>
                          <span class="visually-hidden">Increase quantity ${prodObj[varId].title}</span>
                          </a>
                      </div>
                  </div>
              </div>
              <div class="mobile-remove-btn ps-2">
                  <a href="#" title="Remove" aria-label="Remove" data-toggle="tooltip" data-remove-item="${varId}" data-index="1" data-placement="left">
                      <i class="icon-delete icon-size-23"></i>
                  </a>
              </div>
          </div>
      </div>
      <div class="text-end fw-bold font-size-md d-flex justify-content-between align-items-center"><span class="fw-normal text-uppercase" style="font-size: 14px;">total:</span>${total} </div>
  </div>`;
    }

    appedHtml += `</div><div class="estimated-total-wrap border-top border-gray-600 pt-4 mt-3">
          <div class="fw-bold font-size-md d-flex justify-content-between align-items-center">
              <span class="h6 mb-0 text-capitalize pe-2">Estimated total</span>
              <span class="text-end" data-update-price>${Shopify.formatMoney(totalPrice, window.globalVariables.money_format)}</span>
          </div>
          <a href="#" class="btn btn-primary btn-block mt-4" data-addbulk-btn>
              <span class="add-text">Place order</span>
              <span class="spinner"></span>
            </a>
          <div class="font-size-md mt-3" style="line-height: 1.2;">
              <p class="">
                  Taxes & shipping are calculated at checkout.
                </p>
                <p>
                  Discounts applied at checkout.
                </p>
          </div>
      </div>`
    orderWrap.innerHTML = appedHtml;

    orderWrap.querySelectorAll('[data-qty-btn]').forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    orderWrap.querySelectorAll('[data-remove-item]').forEach(removeele => {
      removeele.addEventListener('click', event => {
        event.preventDefault();
        let varId = event.currentTarget.getAttribute('data-remove-item');
        document.querySelector('[data-b2b-product="' + varId + '"]').remove();//remove div HTML from order summary tab
        totalPrice = totalPrice - (prodObj[varId].price * prodObj[varId].qty);
        delete prodObj[varId];//delete from product object
        orderWrap.querySelector('[data-update-price]').innerHTML = Shopify.formatMoney(totalPrice, window.globalVariables.money_format)
        addItemsFinal.splice(addItemsFinal.findIndex(v => v.id === varId), 1); //to remove item from add to cart object
        if (addItemsFinal.length == 0) {
          orderWrap.innerHTML = '<p>Add Products.</p>';
        }
        if (document.querySelector('input[value="' + varId + '"]') != null) {
          document.querySelector('input[value="' + varId + '"]').closest('form').querySelector('input[name="quantity"]').value = 0;
          if(document.querySelector('input[value="' + varId + '"]').closest('form').querySelector('[data-purchase-btn]') != null){
            document.querySelector('input[value="' + varId + '"]').closest('form').querySelector('[data-purchase-btn]').classList.add('btn-bulk-button')
          }
        }
      })
    });

    // console.log(addItemsFinal, 'addItemsFinal', addItemsFinal.length)
    orderWrap.querySelector('[data-addbulk-btn]').addEventListener('click', (e) => {
      e.preventDefault();
      e.currentTarget.classList.add('loading')
      this.addBulkOrder(addItemsFinal);
    })
  }

  addBulkOrder(addItemsFinal) {
    const body = JSON.stringify({
      items: addItemsFinal
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        window.location.href = "/checkout";
      })
      .catch((e) => {
        console.error(e);
        alert(e);
      });
  }

  displayPrice(event) {
    let currentTarget = event.currentTarget;
    this.price = 0;
    if (this.form.querySelectorAll('[data-var-price]:checked').length > 1) {
      this.form.querySelectorAll('[data-var-price]:checked').forEach(fprice => {
        let varPrice = fprice.getAttribute('data-var-price');
        this.price = this.price + parseInt(varPrice);
      });
      console.log(this.price)
      document.querySelector('[data-currentprice]').innerHTML = Shopify.formatMoney(this.price, window.globalVariables.money_format);
      //console.log(Shopify.formatMoney(this.price, window.globalVariables.money_format));
    }
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    // if (this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    if (this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option' + option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == 'grid') {
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if (currentVariant.sku != null) {
      if (this.form.closest('.card-body') != null && this.form.closest('.card-body').querySelector('.pd-sku') != null) {
        this.form.closest('.card-body').querySelector('.pd-sku span').innerHTML = '#' + currentVariant.sku;
      }
    }
    
    let actualPrice = currentVariant.price;
    
    if (container.querySelector('[data-purchase-btn]') || container.querySelector('[data-currentPrice]').hasAttribute('data-actual-price')) {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(container.querySelector('noscript').textContent, 'text/html');
      actualPrice = htmlDoc.querySelector('[data-variant-id="' + currentVariant.id + '"]').getAttribute('data-price')
      price = Shopify.formatMoney(actualPrice, window.globalVariables.money_format);
      if(container.querySelector('[data-bulk-price]') != null){
        container.querySelector('[data-bulk-price]').setAttribute('value', actualPrice);
      }
    }

    if (priceElement) {
      priceElement.innerHTML = price;
      priceElement.setAttribute('data-actual-price', actualPrice)
    }
    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price <= 0) {
        comparePriceElement.style.display = 'none';
      } else {
        comparePriceElement.style.display = 'inline-block';
      }
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option' + option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });

    // Grid Image Update on variant selection
    if (this.formType == 'grid') {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if (this.formType == 'quickshop') {
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }

  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if (this.form.classList.contains('cart-upsell-form')) {
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      } else {
        if (this.addBtn.closest('[data-purchase-btn]')) {
          this.addBtn.querySelector('.add-text').textContent = 'add';
        } else {
          this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
        }
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        if(swatch.querySelector('[data-var-swatch]') != null){
          swatch.querySelector('[data-var-swatch]').setAttribute('style', swatchStyle);
        }
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);